/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface HealthCheckEntry
 */
export interface HealthCheckEntry {
  /**
   *
   * @type {string}
   * @memberof HealthCheckEntry
   */
  status?: string | null;
  /**
   *
   * @type {number}
   * @memberof HealthCheckEntry
   */
  responseTimeMs?: number | null;
  /**
   *
   * @type {string}
   * @memberof HealthCheckEntry
   */
  error?: string | null;
}

export function HealthCheckEntryFromJSON(json: any): HealthCheckEntry {
  return HealthCheckEntryFromJSONTyped(json, false);
}

export function HealthCheckEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCheckEntry {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: !exists(json, "status") ? undefined : json["status"],
    responseTimeMs: !exists(json, "responseTimeMs") ? undefined : json["responseTimeMs"],
    error: !exists(json, "error") ? undefined : json["error"],
  };
}

export function HealthCheckEntryToJSON(value?: HealthCheckEntry | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: value.status,
    responseTimeMs: value.responseTimeMs,
    error: value.error,
  };
}
